import Delta from 'quill-delta';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { EvaluationSubmissionDocument } from '@treams/treams-network';
import { Modal, Popover, QuillInput } from '@treams/treams-ui';

export default function EvaluationNoteComposerModal(props: {
	submissionID: string;
	itemID?: string;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [value, setValue] = useState(new Delta());
	const [loading, setLoading] = useState(false);

	const [create] = graphql.useCreateCommentMutation({
		variables: {
			input: {
				targetID: props.submissionID,
				targetType: graphql.CommentTargetType.EvaluationSubmission,
				content: value,
				metadata: props.itemID
					? [
							{
								key: 'formItemID',
								value: props.itemID,
							},
						]
					: [],
			},
		},
	});

	const onCreate = async () => {
		if (loading) {
			return;
		}

		setLoading(true);

		await create({
			refetchQueries: [EvaluationSubmissionDocument, props.submissionID],
			onCompleted: () => {
				props.onDismiss();
			},
		});
	};

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('evaluation.submission.notes.addButton.title')}
					onClose={props.onDismiss}
				/>
				<Modal.Contents>
					<QuillInput value={value} onChange={setValue} />
				</Modal.Contents>

				<Modal.FormFooter onSave={onCreate} saveTitle={t('notes.items.add.buttonTitle')} />
			</Modal>
		</Popover>
	);
}
